export default {
  paymentLegalDisclaimer: {
    id: 'klarna_financing_disclaimer',
    defaultMessage:
      'Back Market is an Introducer Appointed Representative of Klarna Financial Services UK Limited, authorised and regulated by the Financial Conduct Authority (FRN 987889).',
  },
} as const
